<template>
  <NuxtLayout
    name="generic"
    header="standardWhite"
    footer="standard"
  >
    <div v-if="data">
      <CaseStudiesHero :data="data.caseStudyHero" />

      <CaseStudiesContent :data="data.caseStudyContent" />

      <CTABanner
        v-if="data.CTABanner?.reference"
        :data="data.CTABanner.reference"
      />

      <SuggestedContent
        v-if="!data.removeSuggestedContent"
        :current-id="data._id"
      />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { queryCaseStudy } from '~/queries/pages/PageCaseStudy.query';
import type { QueryCaseStudyResult } from '~/sanity/types';
import CaseStudiesHero from '~/components/Organisms/CaseStudies/CaseStudiesHero.vue';
import CaseStudiesContent from '~/components/Organisms/CaseStudies/CaseStudiesContent.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';
import SuggestedContent from '~/components/Organisms/SuggestedContent/SuggestedContent.vue';
import { extractAbstractFromPortableText } from '~/utils/extractBreakoutSummary';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryCaseStudyResult>(queryCaseStudy, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  title: data.value?.htmlTitle || data.value?.title,
  twitterCard: 'summary',
  structuredData: [
    {
      schemaType: 'TechArticle',
      description: data.value?.ogDescription || data.value?.description,
      contentSummary: data.value?.description, // this needs to be added to sanity schema, use 'tldr summary'
      abstract: extractAbstractFromPortableText(
        data.value?.caseStudyContent?.content?.blogPortableText
      ),
      title: data.value?.htmlTitle || data.value?.title,
      imageRef: data.value?.ogImage?.asset?._ref || data.value?.cardImage?.asset?._ref,
      dateModified: data.value?._updatedAt,
      // the following fields are currently not in the sanity schema for case studies,
      // but if they are added in the future, they should be used here
      // datePublished: data.value?.datePublished,
      // dateModified: data.value?.dateModified,
      // authorName: data.value?.authorName,
      // authorUrl: data.value?.authorUrl,
      // imageUrl:
      //   data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
      enabled: true,
    },
  ],
});
</script>
